import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid2';
import Skeleton from '@mui/material/Skeleton';

const LeaderBoardCurrentUserInfoSkeleton = () => (
  <Grid
    container
    alignItems="center"
    sx={{
      backgroundColor: 'background.paper',
      borderRadius: '12px',
      px: 2,
      minHeight: 74,
      width: '100%',
      m: 0,
      flexWrap: 'nowrap',
    }}>
    {/* Avatar Skeleton */}
    <Box sx={{mr: 2}}>
      <Skeleton variant="circular" width={54} height={54} />
    </Box>

    {/* Name and Rank */}
    <Box sx={{flexGrow: 1}}>
      <Skeleton variant="text" width={100} height={25} sx={{mb: 1}} />
      <Skeleton variant="text" width={60} height={20} />
    </Box>

    {/* Trophy and Level */}
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        minWidth: 71,
      }}>
      <Skeleton
        variant="rectangular"
        width={40}
        height={15}
        sx={{mb: 1, borderRadius: 1}}
      />
      <Skeleton variant="text" width={50} height={20} />
    </Box>
  </Grid>
);

export default LeaderBoardCurrentUserInfoSkeleton;
